<template>
  <div class="select">
    <button
      class="select-button select-order"
      :class="{'is-active': isVisibleOrderSelectBox}"
      @click="$emit('clickedOrder')"
    >
      <svg class="select-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.31 13" width="11" height="13" preserveAspectRatio="xMinYMid">
        <g>
          <path class="cls-1" d="M10.19,10.34a.41.41,0,0,0-.59,0L8.36,11.57V.42a.42.42,0,1,0-.84,0V11.57L6.29,10.34a.42.42,0,0,0-.59.59l2,2a.42.42,0,0,0,.29.12.42.42,0,0,0,.3-.12l1.95-2A.42.42,0,0,0,10.19,10.34Z"/>
          <path class="cls-1" d="M2.66.12a.42.42,0,0,0-.59,0L.12,2.07a.42.42,0,0,0,0,.59.4.4,0,0,0,.59,0L2,1.43V12.58a.42.42,0,0,0,.84,0V1.43L4,2.66a.41.41,0,0,0,.6,0,.42.42,0,0,0,0-.59Z"/>
        </g>
      </svg>
      <span class="select-button-text1">並べ替え：</span>
      <span class="select-button-text2" v-html="orderText" />
    </button>
    <button
      class="select-button select-choices"
      :class="{'is-active': isVisibleChoiceSelectBox}"
      @click="$emit('cliedChoices')"
    >
      <svg class="select-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.1 8.64" width="13" height="9" preserveAspectRatio="xMinYMid">
        <g>
          <path class="cls-1" d="M8.78,3.62a1.81,1.81,0,0,0,1.76-1.39h2.14a.42.42,0,0,0,0-.84H10.54A1.81,1.81,0,1,0,8.78,3.62Zm0-2.78a1,1,0,0,1,0,2,1,1,0,1,1,0-1.95Z"/>
          <path class="cls-1" d="M.42,2.23h5a.42.42,0,1,0,0-.84h-5a.42.42,0,0,0,0,.84Z"/>
          <path class="cls-1" d="M4.32,5A1.8,1.8,0,0,0,2.56,6.41H.42a.42.42,0,0,0,0,.84H2.56A1.81,1.81,0,1,0,4.32,5Zm0,2.78a1,1,0,1,1,1-1A1,1,0,0,1,4.32,7.8Z"/>
          <path class="cls-1" d="M12.68,6.41H7.38a.42.42,0,0,0,0,.84h5.3a.42.42,0,1,0,0-.84Z"/>
        </g>
      </svg>
      <span class="select-button-text">絞り込み</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SortResultSortSelect',
  props: {
    orderText: {
      type: String,
      default: ''
    },
    isVisibleOrderSelectBox: {
      type: Boolean,
      default: false
    },
    isVisibleChoiceSelectBox: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  display: flex;
  justify-content: space-between;
  width: 295/375 * 100%;
  margin: 28/375 * 100% auto 0;
  @include media() {
    max-width: 800px;
    margin: 60px auto 0;
  }
  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #DF0468;
    padding: 14px 0;
    border-radius: 30px;
    color: #DF0468;
    white-space: nowrap;
    width:calc(68% - 5px);

    @include media() {
      width:auto;
      padding-left:25px;
      padding-right:25px;
    }

    &:last-child{
      width:calc(32% - 5px);
      @include media() {
        width:auto;
      }
    }



    @include media() {
      cursor: pointer;
    }
    & + .select-button {
      margin-left: 10px;
    }
    &:hover,
    &.is-active {
      background: #DF0468;
      color: #fff;
    }
    &-icon {
      margin-right: 5/375 * 100vw;
      fill: #DF0468;
      @include media() {
        margin-right: 6px;
        transition: .3s ease;
        .select-button:hover & {
          fill: #fff;
        }
      }
      .is-active & {
        fill: #fff;
      }
      .select-order & {
        width: 9/295 * 100vw;
        height: auto;
        @include media() {
          width: 10px;
        }
      }
      .select-choices & {
        width: 11/295 * 100vw;
        height: auto;
        @include media() {
          width: 13px;
        }
      }
    }
    &-text,
    &-text1,
    &-text2 {
      font-size: 11/375 * 100vw;
      line-height: 1;
      @include media() {
        font-size: 12px;
        transition: .3s ease;
        .select-button:hover & {
          color: #fff;
        }
      }
      .is-active & {
        color: #fff;
      }
    }
  }
}
</style>
